<template>
  <div style="padding: 0px" class="sub-view">
    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Tanggal Pengajuan</th>
          <th style="width: 30%">Nama Karyawan</th>
          <th>Cabang</th>
          <th>Waktu</th>
          <th>Tipe</th>
          <th>Lampiran</th>
          <th>HR Review</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr :key="index" v-for="(presensi, index) in filteredRiwayatPresensi">
          <!-- tanggal pengajuan -->
          <td>{{ presensi.tanggalPengajuan }}</td>
          <!-- Nama Karyawan  -->
          <td>
            <span style="color: #1d1d1d; font-weight: 700">{{
              presensi.nama
            }}</span>
            <br />
            {{ presensi.jabatan }}-{{ presensi.divisi }}
          </td>
          <!-- Cabang  -->
          <td>
            {{ userData.penempatan }}
          </td>
          <!-- waktu presensi untuk tipe presensi  -->
          <td v-if="presensi.tipe === 'presensi'">
            Mulai:
            <span class="red-text">{{
              toClock(presensi.masukTime._seconds)
            }}</span>
            <br />
            Akhir:
            <span v-if="presensi.keluarTime" class="red-text">{{
              toClock(presensi.keluarTime._seconds)
            }}</span>
            <span v-else class="red-text">-</span>
          </td>

          <!-- waktu presensi untuk tipe absen dan cuti  -->
          <td v-else>
            Mulai:
            <span class="red-text">{{ presensi.tanggalMulai }}</span>
            <br />
            Akhir:
            <span class="red-text">{{ presensi.tanggalAkhir }}</span>
          </td>

          <!-- tipe  -->
          <td v-if="presensi.tipe === 'absen'" class="tipe-absen">
            <span>Absen</span>
          </td>
          <td v-else-if="presensi.tipe === 'cuti'" class="tipe-cuti">
            <span>Cuti</span>
          </td>
          <td v-else class="tipe-presensi"><span>Presensi</span></td>

          <!-- lampiran presensi -->
          <td v-if="presensi.tipe === 'presensi'" class="tabel-lampiran">
            <!-- lampiran masuk  -->
            <p
              @click="
                openCloseModal(
                  true,
                  presensi.masukPicture[0],
                  presensi.masukLocation
                )
              "
            >
              <span>Masuk</span>
            </p>
            <!-- lampiran keluar  -->
            <p
              @click="
                openCloseModal(
                  true,
                  presensi.keluarPicture[0],
                  presensi.keluarLocation
                )
              "
              v-if="presensi.keluarPicture && presensi.keluarLocation"
            >
              <span>Akhir</span>
            </p>

            <p style="color: #a0a3bd" v-else>
              <span>Akhir</span>
            </p>
          </td>
          <!-- lampiran absen dan cuti -->
          <td v-else class="tabel-lampiran">
            <p @click="openCloseModalKeterangan(true, presensi.keterangan)">
              <span>Keterangan</span>
            </p>
            <p @click="openCloseModalViewer(true, presensi.lampiran[0])">
              <span>Dokumen</span>
            </p>
          </td>

          <!-- aksi -->
          <td style="justify-content: space-around" class="aksi">
            <!-- acc -->
            <svg
              @click="
                kirimReview(presensi.tipe, presensi.documentId, 'accepted')
              "
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7143 5.71387L7.85719 13.571L4.28577 9.99958"
                stroke="#27AE60"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <!-- tolak -->
            <svg
              @click="
                kirimReview(presensi.tipe, presensi.documentId, 'rejected')
              "
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2857 5.71387L5.71423 14.2853M5.71423 5.71387L14.2857 14.2853"
                stroke="#EB5757"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p v-if="isProsesData" class="empty-state-table">Memproses data..</p>
      <p
        v-else-if="
          !filteredRiwayatPresensi || filteredRiwayatPresensi.length === 0
        "
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>

    <!-- modal untuk liat lokasi dan foto -->
    <div v-if="modalIsOpen" class="modal-backdrop">
      <div style="width: 445px; height: 458px" class="modal">
        <div class="content">
          <div style="text-align: center" class="text-modal">
            <h2 class="primary-text">
              Lokasi Presensi Masuk
              <svg
                style="margin-left: 8px; cursor: pointer"
                @click="openGmap"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2866 7.71415V11.9999C11.2866 12.3787 11.136 12.7421 10.8681 13.01C10.6002 13.2779 10.2369 13.4284 9.85798 13.4284H2.00084C1.62196 13.4284 1.25859 13.2779 0.990684 13.01C0.722775 12.7421 0.572266 12.3787 0.572266 11.9999V4.14272C0.572266 3.76384 0.722775 3.40047 0.990684 3.13257C1.25859 2.86466 1.62196 2.71415 2.00084 2.71415H6.28655M9.14369 0.571289H13.4294M13.4294 0.571289V4.857M13.4294 0.571289L5.57227 8.42843"
                  stroke="#FFB700"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </h2>
            <h3 style="font-size: 14px; font-weight: 400; margin-top: 10px">
              {{ dataModal.namaLokasi }}
            </h3>
            <img
              style="width: 160px; height: 220px; object-fit: cover"
              :src="dataModal.urlGambar"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <!-- close button -->
        <svg
          style="margin-right: -374px; margin-top: -379px"
          @click="openCloseModal(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of close button -->
      </div>
    </div>
    <!-- end of modal untuk liat lokasi dan foto -->

    <!-- modal untuk keterangan -->
    <div v-if="modalKeteranganIsOpen" class="modal-backdrop">
      <div style="width: 445px; height: 220px" class="modal">
        <div class="content">
          <div style="text-align: center" class="text-modal">
            <h2 class="primary-text">Keterangan</h2>
            <p style="font-size: 14px; font-weight: 400; margin-top: 10px">
              {{ keterangan }}
            </p>
          </div>
        </div>
        <!-- close button -->
        <svg
          style="margin-right: -374px; margin-top: -162px"
          @click="openCloseModalKeterangan(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of close button -->
      </div>
    </div>
    <!-- end of modal untuk keterangan -->

    <!-- modal view lampiran -->
    <ModalViewer v-if="modalViewerIsOpen">
      <div style="text-align: center" class="modal-content">
        <object
          style="object-fit: cover; margin: 10px 0px"
          :data="urlLampiran"
          width="750"
          height="390"
        ></object>

        <button
          @click="openDokumen"
          style="margin-top: 10px"
          class="yellow-button"
        >
          Buka dokumen
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalViewer(false)"
        style="margin-top: -438px; margin-left: 340px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalViewer>
    <!-- end of modal view lampiran -->

    <!-- modal berhasil -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasil(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil -->
  </div>
</template>

<script>
import * as soluhaApi from "@/soluhaApi";
import * as soluhafire from "@/soluhafire";
import { mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import ModalViewer from "@/components/modal/RelativeModal";
import ModalBerhasil from "@/components/modal/ModalAlert";

export default {
  components: {
    ModalViewer,
    ModalBerhasil,
  },

  data() {
    return {
      modalIsOpen: false,
      modalBerhasilIsOpen: false,
      modalKeteranganIsOpen: false,
      modalViewerIsOpen: false,
      // yang akan diambil dari api
      riwayatPresensi: null,
      // data untuk modal lokasi
      dataModal: {
        urlGambar: "",
        urlLokasi: "",
        namaLokasi: "",
      },
      // data modal keterangan
      keterangan: "",
      // data modal view
      urlLampiran: "",
      // apakah tabel sedang memproses data?
      isProsesData: false,
    };
  },

  methods: {
    async rekapPresensi() {
      this.isProsesData = true;
      let listPresensi = await soluhaApi.rekapPresensi();
      let listAbsen = await soluhaApi.riwayatAbsen();
      let listCuti = await soluhaApi.riwayatCuti();
      // buat field tanggal dan tipe untuk presensi
      listPresensi.forEach((element) => {
        element.tanggalPengajuan = element.masukTime._seconds;
        element.tipe = "presensi";
      });
      // buat field tanggal dan tipe untuk absen
      listAbsen.forEach((element) => {
        element.tanggalPengajuan = element.tanggalPengajuan._seconds;
        element.tanggalMulai = soluhaApi.epochToDate(
          element.tanggalMulai._seconds
        );
        element.tanggalAkhir = soluhaApi.epochToDate(
          element.tanggalAkhir._seconds
        );
        element.tipe = "absen";
      });
      // buat field tanggal dan tipe untuk cuti
      listCuti.forEach((element) => {
        element.tanggalPengajuan = element.tanggalPengajuan._seconds;
        element.tanggalMulai = soluhaApi.epochToDate(
          element.tanggalMulai._seconds
        );
        element.tanggalAkhir = soluhaApi.epochToDate(
          element.tanggalAkhir._seconds
        );
        element.tipe = "cuti";
      });
      let rekapPresensi = [...listPresensi, ...listAbsen, ...listCuti];
      // sorting berdasarkan tanggal pengajuan
      rekapPresensi.sort((a, b) => b.tanggalPengajuan - a.tanggalPengajuan);
      rekapPresensi.forEach((element) => {
        element.tanggalPengajuan = soluhaApi.epochToDate(
          element.tanggalPengajuan
        );
      });
      this.riwayatPresensi = rekapPresensi;
      this.isProsesData = false;
    },

    openCloseModal(isOpen, picture, location) {
      if (isOpen) {
        this.geocoding(location);
        this.modalIsOpen = true;
        this.dataModal.urlGambar = picture;
        this.dataModal.urlLokasi = `https://maps.google.com/?q=${location.latitude},${location.longitude}`;
      } else this.modalIsOpen = false;
    },

    openCloseModalKeterangan(isOpen, keterangan) {
      if (isOpen) {
        this.keterangan = keterangan;
        this.modalKeteranganIsOpen = true;
      } else {
        this.keterangan = "";
        this.modalKeteranganIsOpen = false;
      }
    },

    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    // buka atau tutup modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    async geocoding(location) {
      let lokasi = {
        lat: location.latitude,
        lng: location.longitude,
      };
      await this.$gmapApiPromiseLazy();
      // reverse geocode
      let geocoder = new this.google.maps.Geocoder();
      let alamat;
      // ada 8 hasil geocode, yang [0] paling lengkap :)
      geocoder.geocode({ location: lokasi }, (result, status) => {
        if (status !== "OK") return;
        if (!result[0]) return;

        alamat = `${result[0].address_components[0].long_name} ${result[0].address_components[2].long_name} ${result[0].address_components[3].long_name}`;
        alamat = alamat.toUpperCase();
        this.dataModal.namaLokasi = alamat;
      });
    },

    openGmap() {
      window.open(this.dataModal.urlLokasi, "_blank");
    },

    toClock(time) {
      return soluhafire.epochToClock(time);
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },

    kirimReview(tipe, documentId, review) {
      this.openCloseModalBerhasil(true);
      // api berdasarkan tipe
      if (tipe === "cuti") {
        soluhaApi.reviewCuti(documentId, review);
      } else if (tipe === "absen") {
        soluhaApi.reviewAbsen(documentId, review);
      } else {
        soluhaApi.reviewPresensi(documentId, review);
      }
      // hapus index yang ada di tabel
      this.riwayatPresensi.splice(
        this.riwayatPresensi.findIndex(
          (item) => item.documentId === documentId
        ),
        1
      );
    },
  },

  mounted() {
    this.rekapPresensi();
  },

  computed: {
    ...mapState(["userData"]),
    google: gmapApi,
    // filter riwayat presensi berdasarkan status === pending
    filteredRiwayatPresensi() {
      let riwayatPresensi = this.riwayatPresensi;
      if (!riwayatPresensi) return riwayatPresensi;
      // pegawai tidak bisa acc presensi sendiri
      if (this.userData.jabatan !== "manager") {
        riwayatPresensi = riwayatPresensi.filter(
          (item) => item.noPegawai !== this.userData.noPegawai
        );
      }
      return riwayatPresensi.filter((item) => item.status === "pending");
    },
  },
};
</script>

<style scoped>
@import url("../../../assets/css/hrd/lembur.css");
</style>
